exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contactCard{margin:100px 250px}.contactCard .btn{margin:10px 10px 0 0;cursor:pointer;font-size:14px;padding:10px 30px;font-weight:400;color:#fff;border-radius:4px;text-transform:uppercase;transition:all .2s linear;display:inline-block;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;border:1px solid transparent;line-height:1.5}.contactCard a{text-decoration:none}.contactCard .btn-common{background-color:#00bcd4;position:relative;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ContactCard.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/ContactCard.scss
// module chunks = 0